// Single source of truth for the app version shown in the UI (Login page, Topbar).
// Keep this in sync with the "version" field in package.json and with the
// latest entry at the top of CHANGELOG.md whenever a release is made.
export const APP_VERSION = "1.1.9";

export default APP_VERSION;
